module.exports = __webpack_public_path__ + "assets/img/no-payment.43d8600.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/no-payment.png
// module id = Rr+D
// module chunks = 1